import { render } from "./ChatBot.vue?vue&type=template&id=6c327a5a&scoped=true"
import script from "./ChatBot.vue?vue&type=script&lang=js"
export * from "./ChatBot.vue?vue&type=script&lang=js"

import "./ChatBot.vue?vue&type=style&index=0&id=6c327a5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c327a5a"]])

export default __exports__